import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import { TL } from "../i18n";

export function useBranding() {
  const [b, setB] = useState(null);
  useEffect(() => { client.get("/public/branding").then((r) => setB(r.data)).catch(() => {}); }, []);
  return b;
}

export default function BrandFooter() {
  const b = useBranding();
  if (!b) return null;
  const lang = (typeof localStorage !== "undefined" && localStorage.getItem("suite_lang")) || "ENG";
  const tm = b.trademark_notice && (b.trademark_notice[lang] || b.trademark_notice.ENG);
  return (
    <footer data-testid="brand-footer"
      className="pointer-events-none fixed inset-x-0 bottom-0 z-30 border-t border-black/5 dark:border-white/10 bg-white/80 dark:bg-neutral-900/80 px-4 py-1.5 text-center text-xs opacity-90 backdrop-blur-sm">
      <div className="mx-auto max-w-none space-y-0">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 opacity-70">
          <Link to="/privacy" className="pointer-events-auto font-medium hover:text-[var(--primary)]" data-testid="footer-privacy-link">{TL("Privacy Policy")}</Link>
          <span>{(b.copyright_notice || "").replace(/All Rights Reserved/i, TL("All Rights Reserved"))}</span>
          <Link to="/cookies" className="pointer-events-auto font-medium hover:text-[var(--primary)]" data-testid="footer-cookies-link">{TL("Cookies Policy")}</Link>
          <Link to="/backup" className="pointer-events-auto font-medium hover:text-[var(--primary)]" data-testid="footer-backup-link">{TL("Backup & Recovery")}</Link>
          <Link to="/terms" className="pointer-events-auto font-medium hover:text-[var(--primary)]" data-testid="footer-terms-link">{TL("Terms of Use")}</Link>
        </div>
        {tm && <div data-testid="brand-trademark-notice" className="overflow-x-auto whitespace-nowrap text-[10px] leading-tight opacity-60">{tm}</div>}
      </div>
    </footer>
  );
}

export function AppFooter() {
  const b = useBranding();
  if (!b) return null;
  const lang = (typeof localStorage !== "undefined" && localStorage.getItem("suite_lang")) || "ENG";
  const tm = b.trademark_notice && (b.trademark_notice[lang] || b.trademark_notice.ENG);
  return (
    <footer data-testid="app-footer"
      className="mt-10 flex flex-col items-center gap-1 rounded-xl border-t border-black/10 dark:border-white/10 bg-white/70 dark:bg-neutral-900/70 px-4 pb-5 pt-5 text-center backdrop-blur-sm">
      <div className="flex items-center gap-2">
        <img src="/brand-logo.png" alt={b.suite_name} className="h-5 w-5 object-contain" />
        <span className="font-head text-sm font-semibold" style={{ color: "var(--logo)" }}>{b.suite_name}</span>
      </div>
      <span className="text-xs opacity-50">{(b.copyright_notice || "").replace(/All Rights Reserved/i, TL("All Rights Reserved"))}</span>
      {tm && <span data-testid="app-trademark-notice" className="w-full overflow-x-auto whitespace-nowrap text-[11px] leading-tight opacity-50">{tm}</span>}
    </footer>
  );
}
